<template>
  <div>
    <gadget-base @hide="hideWidget" v-loading="isLoading">
      <div>
        <ul class="count person" v-bind:class="{full: (achivementRate >= 100)}">
          <li class="result">
            <h3>客数</h3>
            <span class="num countup" data-val="396955">{{ person|addFigure }}</span>
          </li>
          <li class="budget">
            <h3>予算</h3>
            <span class="num">{{ budget|addFigure }}</span>
          </li>
          <li class="ratio">
            <h3>達成率</h3>
            <span class="num">{{ achivementRate }}</span>
          </li>
          <li class="bar" style="padding-bottom: 5px">
            <span v-bind:style="barStyle"></span>
          </li>
        </ul>
      </div>
    </gadget-base>
  </div>
</template>

<script>
import GadgetBase from './GadgetBase'

export default {
  name: 'PersonCountGadget',
  props: {
    targetDate: {
      type: Object,
      required: true,
    },
  },
  watch: {
    targetDate (val) {
      this.fetchData()
    },
  },
  data () {
    return {
      isLoading: false,
      person: null,
      budget: null,
    }
  },
  computed: {
    achivementRate () {
      if (!this.person || !this.budget) {
        return 0
      }
      return Math.round(this.person / this.budget * 1000) / 10
    },
    barStyle () {
      let width = this.achivementRate > 100 ? 100 : this.achivementRate
      return {
        width: width + '%',
      }
    },
  },
  methods: {
    fetchData () {
      this.isLoading = true
      this.$request.salesBudgets.detail(this.targetDate.format('YYYY-MM-DD')).then(res => {
        this.person = res.body.currentPerson
        this.budget = res.body.person
      }).finally(() => {
        this.isLoading = false
      })
    },
    hideWidget () {
      this.$emit('hide')
    },
  },
  mounted () {
    this.fetchData()
  },
  components: {
    GadgetBase,
  },
}
</script>

<style scoped>

ul.count {
  width: 100%;
  height: auto;
  box-sizing: border-box;
  padding: 10px;
  overflow: hidden;
  background-color: #FFF;
  box-shadow: 1px 1px 1px rgba(0,0,0,0.1);
  margin-bottom: 0px;
}
ul.count li {
  display: block;
  width: 100%;
  color: #567;
  float: left;
}
ul.count li.result {
  padding-bottom: 10px;
}
ul.count li.budget,
ul.count li.ratio {
  width: 50%;
  padding-bottom: 10px;
}

ul.count li .num {
  display: block;
  text-align: right;
  font-size: 20px;
}
ul.count li .num:after {
  padding-left: 0.25em;
  font-size: 0.5em;
  font-weight: bold;
  vartical-align: 1px;
}

ul.count li.ratio .num {
  color: #E34;
}
ul.count.full li.ratio .num {
  color: #567;
}

ul.count li.result .num:after,
ul.count li.budget .num:after {
  content: '人';
}
ul.count li.ratio .num:after {
  content: '％';
}

ul.count li.bar {
  position: absolute;
  height: 3px;
  bottom: 5px;
  left: 0;
  background-color: #E3E6E9;
}

ul.count li.bar > span {
  display: block;
  width: 0;
  height: 100%;
  background-color: #E34;
}

ul.count.full li.bar > span {
  background-color: #39D;
}


ul.count li h3 {
  font-size: 14px;
  font-weight: normal;
}

ul.count li.result .num {
  font-size: 32px;
}

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/PersonCount.vue